import { Component, OnDestroy, OnInit } from '@angular/core';
import { StreamingMedia, StreamingAudioOptions } from '@ionic-native/streaming-media/ngx';
import { ToastController, Platform } from '@ionic/angular';
import { HttpClient } from '@angular/common/http';
import { DatabaseCollectionProvider } from '@library/core-database/src/public_api';
import { AppSettings } from '@library/plugin-settings/src/public_api';
import * as moment from 'moment';
import { NavigationEnd, Router } from '@angular/router';
import { PodcastActivityService } from './podcast-activity.service';

@Component({
    selector: 'plugin-exercise',
    templateUrl: './exercise.component.html',
    styleUrls: ['./exercise.component.scss'],
})
export class ExerciseComponent implements OnInit {
    info: any;
    domain: string;
    isMobile: boolean;
    currentAudioPlayer: HTMLAudioElement;

    constructor(
        private stream: StreamingMedia,
        private http: HttpClient,
        private toastCtrl: ToastController,
        private collectionProvider: DatabaseCollectionProvider,
        private platform: Platform,
        private settings: AppSettings,
        private router: Router,
        private podcastActivityService: PodcastActivityService,
    ) {}

    async ngOnInit() {
        await this.settings.awaiter();
        this.isMobile = (this.platform.is('android') || this.platform.is('ios')) && this.platform.is('cordova');
        this.domain = await this.collectionProvider.getApiDomain();
        try {
            this.http.get(`https://${this.domain}/static/mia/podcasts.json`).subscribe((data: any) => {
                if (JSON.stringify(this.info) != JSON.stringify(data)) {
                    const startDate = moment.unix(this.settings.get('init-timestamp'));
                    data.podcasts.forEach((podcast) => {
                        if (moment().subtract(podcast.unlockAfter, 'days').isAfter(startDate)) {
                            podcast.unlocked = true;
                        } else {
                            podcast.unlocked = false;
                        }
                    })
                    this.info = data;
                }
            });
        } catch (error) {
            console.log('error >>>', error);
            this.displayToastError();
        }

        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                if (this.currentAudioPlayer) {
                    this.currentAudioPlayer.pause();
                    this.currentAudioPlayer = null;
                }
            }
        })
    }

    play(podcast: any) {
        if (navigator.onLine) {
            let options: StreamingAudioOptions = {
                initFullscreen: true,
                bgImage: `https://${this.domain}/static/mia/${podcast.backgroundImage}`,
                bgImageScale: 'fit',
                keepAwake: true,
                errorCallback: (e) => {
                    console.log(e);
                    this.displayToastError();
                },
            };
            const audioFileUrl = `https://${this.domain}/static/mia/${podcast.fileName}`;
            this.stream.playAudio(audioFileUrl, options);
        } else {
            this.displayToastError();
        }
    }

    async displayToastError() {
        let toast = await this.toastCtrl.create({
            message: 'Verbindungsfehler, bitte versuchen Sie es später erneut',
            duration: 3000,
            position: 'bottom',
        });
        toast.present();
    }

    async refreshView(event: any) {
        event.target.disabled = true;
        await this.ngOnInit();
        setTimeout(() => {
            event.target.complete();
            event.target.disabled = false;
        }, 2000);
    }

    getSource(podcast: any) {
        return `https://${this.domain}/static/mia/${podcast.fileName}`;
    }

    logActivity(type: string, element: HTMLAudioElement, payload = {}) {
        this.podcastActivityService.saveActivity({
            type,
            file: element.currentSrc.split('/').pop(),
            createdAt: new Date(),
            data: {
                url: element.currentSrc,
                currentTime: element.currentTime,
                duration: element.duration,
                progress: Math.floor((element.currentTime / element.duration) * 10000) / 100,
                ...payload
            }
        })
    }

    onAbort($event: UIEvent) {
        this.currentAudioPlayer = null;
        this.logActivity('abort', $event.target as HTMLAudioElement);
    }

    onEnded($event: Event) {
        this.currentAudioPlayer = null;
        this.logActivity('ended', $event.target as HTMLAudioElement);
    }

    onPause($event: Event) {
        this.currentAudioPlayer = null;
        this.logActivity('pause', $event.target as HTMLAudioElement);
    }

    onPlay($event: Event) {
        this.currentAudioPlayer = null;
        this.logActivity('play', $event.target as HTMLAudioElement);
    }

    onPlaying($event: Event) {
        this.currentAudioPlayer = $event.target as HTMLAudioElement;
        this.logActivity('playing', $event.target as HTMLAudioElement);
    }
}

